import React, { useEffect } from "react";
import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import Mfa from "./Mfa";
import { useAuthenticationConfiguration } from "./Configuration";
import { useNavigate } from "react-router-dom";

const MfaContainer: React.FC = () => {
    const navigate = useNavigate();
    const configuration = useAuthenticationConfiguration();
    const {
        state,
        fetchPasskeys,
        addPasskey,
        renamePasskey,
        deletePasskey,
        generateTotpKey,
        disableTotp,
        generateRecoveryCodes,
    } = useAuthenticationStore();
    const { serverError, isLoading, isTotpEnabled, passkeys } = state;

    useEffect(() => {
        const init = async () => {
            if (configuration.passkeyServerBaseUrl) {
                await fetchPasskeys();
            }
        };
        init();
    }, []);

    const addTotp = async () => {
        if (await generateTotpKey()) {
            navigate("../" + AuthenticationViews.addTotp);
        }
    };

    return (
        <Mfa
            serverError={serverError}
            isLoading={isLoading}
            passkeysEnabled={!!configuration.passkeyServerBaseUrl}
            passkeys={passkeys}
            totpEnabled={isTotpEnabled ?? false}
            addPasskey={addPasskey}
            renamePasskey={renamePasskey}
            deletePasskey={deletePasskey}
            addTotp={addTotp}
            removeTotp={disableTotp}
            generateRecoveryCodes={generateRecoveryCodes}
        />
    );
};

export default MfaContainer;
